


import React, { FC, useState, useEffect } from "../../../lib/teact/teact";


import { DBManager } from "../db/dbManager";
import LotInputtext from "../ui/lotInputtext";
import LotSelect from "../ui/lotSelect";
import { globalDexieDb } from "../db/DexiedbLib";
import { isValidTime } from "../utils/DateTimeUtils";
import { GetUserID } from "../utils/common";
import { IDaiGioChot } from "../db/model/dmdai";

type OwerProp = {
    thu: number;
    tinhId: string;
    mienDaiCuoc: number;
    onDataChange: (fieldName: string, value: any) => void;
    forceUpdate: () => void;
    dai1: "",
    dai2: "",
    dai3: "",
    dai4: "",
    trigger: string;
}

const ThuDaiItem: FC<OwerProp> = ({
    thu,
    tinhId,
    mienDaiCuoc,
    onDataChange,
    forceUpdate,
    dai1,
    dai2,
    dai3,
    dai4,
    trigger,
}) => {

    const [state, setState] = useState({
        dai1: dai1,
        dai2: dai2,
        dai3: dai3,
        dai4: dai4,
        dai1Mo: '',
        dai1Dong: '',
        dai2Mo: '',
        dai2Dong: '',
        dai3Mo: '',
        dai3Dong: '',
        dai4Mo: '',
        dai4Dong: '',
    })
    const daiQuayTrongThu = (() => {
        const tmp: string[] = [];
        if (dai1 != "")
            tmp.push(dai1);
        if (dai2 != "")
            tmp.push(dai2);
        if (dai3 != "")
            tmp.push(dai3);
        if (dai4 != "")
            tmp.push(dai4);
        return tmp;
    })()
    function handleDataChange(fieldName: string, newValue: string) {
        let result: any;
        let oldValue;// đẩy sang cho fieldName bị chiếm mất
        let oldFieldName = "";
        result = {
            tinhId: tinhId, thu: thu,
            dai1: state.dai1,
            dai2: state.dai2,
            dai3: state.dai3,
            dai4: state.dai4
        }
        oldValue = result[fieldName];// giá tri trước khi update, lưu lại để gán lại cho ô bị chiếm
        if (state.dai1 == newValue) {
            oldFieldName = "dai1";
        } else
            if (state.dai2 == newValue) {
                oldFieldName = 'dai2';
            } else if (state.dai3 == newValue) {
                oldFieldName = 'dai3';
            } else
                if (state.dai4 == newValue) {
                    oldFieldName = 'dai4';
                }
        switch (fieldName) {
            case "dai1":
                result = { ...result, dai1: newValue };
                break;
            case "dai2":
                result = { ...result, dai2: newValue };
                break;
            case "dai3":
                result = { ...result, dai3: newValue };
                break;
            case "dai4":
                result = { ...result, dai4: newValue };
                break;
        }
        result[oldFieldName] = oldValue;
        setState(prev => ({ ...prev, ...result }))
        onDataChange(fieldName, result)
    }
    useEffect(() => {
        const userId = GetUserID()
        const loadDai = async () => {
            let daiData = await globalDexieDb.daiGioChot.where('daiId').equals(state.dai1)
                .and(function (item) {
                    return item.userId + "" == userId
                }).first()

            if (daiData && daiData != undefined) {
                setState(prev => ({ ...prev, dai1Mo: daiData!.gioMoThuong, dai1Dong: daiData!.gioRaDacBiet }))
            }
            daiData = await globalDexieDb.daiGioChot.where('daiId').equals(state.dai2).and(function (item) {
                return item.userId + "" == userId
            }).first()
            if (daiData && daiData != undefined) {
                setState(prev => ({ ...prev, dai2Mo: daiData!.gioMoThuong, dai2Dong: daiData!.gioRaDacBiet }))
            }
            daiData = await globalDexieDb.daiGioChot.where('daiId').equals(state.dai3).and(function (item) {
                return item.userId + "" == userId
            }).first()
            if (daiData && daiData != undefined) {
                setState(prev => ({ ...prev, dai3Mo: daiData!.gioMoThuong, dai3Dong: daiData!.gioRaDacBiet }))
            }
            daiData = await globalDexieDb.daiGioChot.where('daiId').equals(state.dai4).and(function (item) {
                return item.userId + "" == userId
            }).first()
            if (daiData && daiData != undefined) {
                setState(prev => ({ ...prev, dai4Mo: daiData!.gioMoThuong, dai4Dong: daiData!.gioRaDacBiet }))
            }
        }
        loadDai().then(res => {

        })
    }, [state.dai1, state.dai2, state.dai3, state.dai4])
    async function handleGioChotChange(daiId: string, gioChotField: string, value: string) {
        const valid = isValidTime(value)
        if (valid) {
            const userId = Number(GetUserID())
            const data: IDaiGioChot | undefined = await globalDexieDb.daiGioChot.where("[userId+daiId]")
                .equals([userId, daiId]).first()
            if (data) {
                if (gioChotField == 'gioMoThuong')
                    data!.gioMoThuong = value
                if (gioChotField == 'gioRaDacBiet')
                    data!.gioRaDacBiet = value
                globalDexieDb.daiGioChot.put(data)
            }

        }
        return valid
    }
    return <>
        <div className="thu-dai-item thu-dai-item-section-item" key={mienDaiCuoc + '-' + thu}>
            <div className=" thu-display"> {thu == 1 ? "CN" : `T${thu}`}</div>
            <div className=" thu-dai-gio-chot">
                <LotSelect value={state.dai1}
                    id={trigger + '-dai1'}
                    key={trigger + '-dai1'}
                    onChange={(e) => {
                        handleDataChange("dai1", e.target.value)

                    }} >
                    {
                        daiQuayTrongThu.map((item, index) => {
                            const selected = state.dai1 == item
                            return <option
                                key={`d1${mienDaiCuoc}${index}`}
                                value={item}
                                selected={selected} >
                                {item}
                            </option>
                        })

                    }
                </LotSelect>
                <input className=" lot-input input-gio-chot" value={state.dai1Mo}
                    onChange={(e) => {
                        handleGioChotChange(state.dai1, "gioMoThuong", e.target.value).then(res => {
                            if (res)
                                setState(prev => ({ ...prev, dai1Mo: e.target.value }))
                        })

                    }}
                />
                <input className=" lot-input input-gio-chot" value={state.dai1Dong}
                    onChange={(e) => {
                        handleGioChotChange(state.dai1, "gioRaDacBiet", e.target.value).then(res => {
                            if (res)
                                setState(prev => ({ ...prev, dai1Dong: e.target.value }))
                        })
                    }} />
            </div>
            <div className=" thu-dai-gio-chot">
                <LotSelect value={state.dai2}
                    id={trigger + '-dai2'}
                    key={trigger + '-dai2'}
                    onChange={(e) => {
                        handleDataChange("dai2", e.target.value)

                    }}>
                    {
                        daiQuayTrongThu.map((item, index) => {
                            return <option
                                key={`d2${mienDaiCuoc}${index}`}
                                value={item}
                                selected={state.dai2 == item}>
                                {item}
                            </option>
                        })

                    }
                </LotSelect>
                <input className=" lot-input input-gio-chot" value={state.dai2Mo}
                    onChange={(e) => {
                        handleGioChotChange(state.dai2, "gioMoThuong", e.target.value).then(res => {
                            if (res)
                                setState(prev => ({ ...prev, dai2Mo: e.target.value }))
                        })
                    }}
                />
                <input className=" lot-input input-gio-chot" value={state.dai2Dong}
                    onChange={(e) => {
                        handleGioChotChange(state.dai2, "gioRaDacBiet", e.target.value).then(res => {
                            if (res)
                                setState(prev => ({ ...prev, dai2Dong: e.target.value }))
                        })
                    }}
                />
            </div>
            {daiQuayTrongThu.length >= 3 &&
                <div className=" thu-dai-gio-chot">
                    <LotSelect value={state.dai3}
                        id={trigger + '-dai3'}
                        key={trigger + '-dai3'}
                        onChange={(e) => {
                            handleDataChange("dai3", e.target.value)

                        }}>
                        {
                            daiQuayTrongThu.map((item, index) => {
                                return <option
                                    key={`d3${mienDaiCuoc}${index}`}
                                    value={item}
                                    selected={state.dai3 == item}>
                                    {item}
                                </option>
                            })

                        }
                    </LotSelect>
                    <input className=" lot-input input-gio-chot" value={state.dai3Mo}
                        onChange={(e) => {
                            handleGioChotChange(state.dai3, "gioMoThuong", e.target.value).then(res => {
                                if (res)
                                    setState(prev => ({ ...prev, dai3Mo: e.target.value }))
                            })
                        }}
                    />
                    <input className=" lot-input input-gio-chot" value={state.dai3Dong}
                        onChange={(e) => {
                            handleGioChotChange(state.dai3, "gioRaDacBiet", e.target.value).then(res => {
                                if (res)
                                    setState(prev => ({ ...prev, dai3Dong: e.target.value }))
                            })
                        }}
                    />
                </div>
            }
            {daiQuayTrongThu.length >= 4 && <div className=" thu-dai-gio-chot">
                <LotSelect value={state.dai4}
                    id={trigger + '-dai4'}
                    key={trigger + '-dai4'}
                    onChange={(e) => {
                        handleDataChange("dai4", e.target.value)

                    }}>
                    {
                        daiQuayTrongThu.map((item, index) => {
                            return <option
                                key={`d4${mienDaiCuoc}${index}`}
                                value={item}
                                selected={state.dai4 == item}>
                                {item}
                            </option>
                        })

                    }
                </LotSelect>
                <input className=" lot-input input-gio-chot" value={state.dai4Mo}
                    onChange={(e) => {
                        handleGioChotChange(state.dai4, "gioMoThuong", e.target.value).then(res => {
                            if (res)
                                setState(prev => ({ ...prev, dai4Mo: e.target.value }))
                        })
                    }}
                />
                <input className=" lot-input input-gio-chot" value={state.dai4Dong}
                    onChange={(e) => {
                        handleGioChotChange(state.dai4, "gioRaDacBiet", e.target.value).then(res => {
                            if (res)
                                setState(prev => ({ ...prev, dai4Dong: e.target.value }))
                        })
                    }}
                />
            </div>
            }
        </div>

    </>
}

export default ThuDaiItem